import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject, Subscription } from 'rxjs';

export class ModalOverlayRef {
  private readonly _afterClosed = new Subject<any>();
  private _result: any;
  constructor(private overlayRef: OverlayRef) {
    this.overlayRef.detachments().subscribe(() => {
      this._afterClosed.next(this._result);
      this._afterClosed.complete();
    });
  }

  public close(data?: any): void {
    this._result = data;
    this.overlayRef.dispose();
  }

  public afterClosed(): Observable<any> {
    return this._afterClosed.asObservable();
  }

  public backgroundClicked() {
    return this.overlayRef.backdropClick().subscribe(() => this.close());
  }

  public subscribeBackdrop(handler: () => void): Subscription {
    return this.overlayRef.backdropClick().subscribe(() => handler());
  }
}
